import React, { useContext, useEffect, useState } from 'react';

import { useMutation } from '@apollo/client';
import { UNREGISTER_FROM_EVENT_MUTATION } from 'Queries/Mutations';
import LocationIcon from 'assets/pics/locationIcon.svg';
import { ReactComponent as ParticipantsIcon } from 'assets/pics/participantsIcon.svg';
import classnames from 'classnames';
import { ParticipantsListContext } from 'context/ParticipantsList';
import { format, isToday } from 'date-fns';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import './EventListGroup.scss';

export const EventListGroupItem = ({ event }) => {
  const { id, path, startDate, endDate, title, registration, deleted, meetingLink } = event;

  const [disabled, setDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { setList } = useContext(ParticipantsListContext);
  const { participants } = registration;

  const [unregisterFromEvent, { data: dataResponseFromUnregisterEvent }] = useMutation(
    UNREGISTER_FROM_EVENT_MUTATION
  );
  const [modalContent, setModalContent] = useState({
    title: 'Wirklich absagen?',
    content: 'Willst du den Termin wirklich für dich und alle deine Teilnehmer absagen?',
  });
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!dataResponseFromUnregisterEvent) return;
    const newContent = {
      ...modalContent,
      title: 'Teilnahme abgesagt',
      content: 'Wir haben deine Absage erhalten...',
    };
    setModalContent(newContent);
    setSuccess(true);
    setDisabled(true);
  }, [dataResponseFromUnregisterEvent]);

  const eventListGroupClasses = classnames('event-list-group-item__wrapper', {
    'event-list-group-item__wrapper--disabled': deleted || disabled,
  });

  const eventListBtn = classnames('event-list-group-item__cta-btn', {
    'event-list-group-item__cta-btn-red': deleted || disabled,
  });

  const handleCancelEventClick = async () => {
    const variables = { eventId: id, unregister: true, participants: [] };
    await unregisterFromEvent({ variables });
  };

  const checkPath = (pathTemp) => {
    setList(false);

    if (pathTemp.startsWith('/')) {
      return pathTemp;
    }
    return `/${pathTemp}`;
  };

  const getModalCtaButtons = () => {
    if (success) {
      return <ActionButton onClick={() => setIsOpen(false)} title="Ok, verstanden" inverted />;
    }

    return (
      <>
        <ActionButton onClick={handleCancelEventClick} title="Absagen" inverted />
        <ActionButton onClick={() => setIsOpen(false)} title="Abbrechen" inverted />
      </>
    );
  };
  const getOnlineEventLink = () => {
    if (!participants.length) {
      return <div>Link nach Anmeldung</div>;
    }
    if (isToday(new Date(event.startDate))) {
      return (
        <a
          href={meetingLink}
          target="_blank"
          rel="noreferrer"
          className="event-meta-data__item-link">
          Jetzt teilnehmen
        </a>
      );
    }
    return <div>Link wird am Veranstaltungstag hier freigeschaltet.</div>;
  };
  return (
    <div className="event-list-group-item">
      <CustomModal
        title={modalContent.title}
        content={
          <div className="event-list-group-item__modal-content-wrapper">{modalContent.content}</div>
        }
        ctaButtons={getModalCtaButtons()}
        isOpen={isOpen}
      />
      <div className="event-list-group-item__outer-wrapper">
        <div className={`${eventListGroupClasses} event-list-group-item__flex-4`}>
          <div>
            <div className="event-list-group-item__info">
              <div className="event-list-group-item__date">
                {startDate && endDate
                  ? format(new Date(startDate), 'dd.MM.yyyy HH:mm') +
                    format(new Date(endDate), ' - HH:mm')
                  : ''}
              </div>
              <div className="event-list-group-item__participants">
                <ParticipantsIcon alt="" className="event-list-group-item__participants-icon" />
                <span className="event-list-group-item__participants-number">
                  {participants.length} Teilnehmer angemeldet
                </span>
              </div>
            </div>
            <div className="event-list-group-item__description">{title}</div>
          </div>
        </div>

        <div className={`${eventListGroupClasses} event-list-group-item__flex-4`}>
          {meetingLink && (
            <div className="event-list-group-item__online-event-outer-wrapper">
              <img
                alt="Location icon"
                src={LocationIcon}
                className="event-list-group-item__location-icon"
              />
              <div className="event-list-group-item__online-event-wrapper">
                <span className="">Online-Veranstaltung</span>
                {getOnlineEventLink()}
              </div>
            </div>
          )}
          {!disabled && !deleted ? (
            <div className="event-list-group-item__wrapper-buttons">
              <button
                type="button"
                className="event-list-group-item__cta-btn"
                onClick={() => setIsOpen(true)}>
                Alle Teilnehmenden abmelden
              </button>

              <Link to={checkPath(path)}>
                <button type="button" className="event-list-group-item__cta-btn">
                  Teilnehmer ändern
                </button>
              </Link>
            </div>
          ) : (
            <div className={eventListBtn}>Veranstaltung Abgesagt</div>
          )}
        </div>
      </div>
    </div>
  );
};
EventListGroupItem.propTypes = {
  event: PropTypes.object.isRequired,
};
